import React, { useContext } from "react"
import { LODGE_STATUS_OPTIONS } from "@stjeans/shared-frontend/filters"
import { OrdersPage as SharedOrdersPage } from "@stjeans/shared-frontend/orders"
import AppContext from "../../AppContext.jsx"
import api from "../../api.js"
import {
    formatStatus,
    getCurrentLocation,
    lastNameCommaFirstName,
    validateConfirmOrder,
    formatTimeDashes,
    address,
    isOverseas,
    sleep,
} from "../../helpers.js"
import OfflineOrdersSection from "../components/orders/OfflineOrdersSection.jsx"

export default function OrdersPage() {
    const { app } = useContext(AppContext)
    // @ts-ignore - Vite injects `import.meta.env` at build time
    const showCloneOrders = Boolean(app?.connected && import.meta.env.VITE_TEST_ORDERS_ENABLED == "true")

    const desktopColumns = [
        { key: "master", label: "Master", sortable: true, preferredWidth: 105, cellType: "text", value: (o) => o.master, cellClassName: "fw-semibold", cellStyle: { color: "#0f6170" } },
        { key: "status", label: "Status", sortable: false, minWidth: 150, preferredWidth: 150, cellType: "status", value: (o) => o.status },
        { key: "firstName", label: "First Name", sortable: false, preferredWidth: 120, cellType: "text", value: (o) => o.firstName },
        { key: "lastName", label: "Last Name", sortable: false, preferredWidth: 140, cellType: "text", value: (o) => o.lastName },
        { key: "fishTag", label: "Fish Tag", sortable: true, filterable: true, preferredWidth: 120, cellType: "text", value: (o) => o.fishTag },
        { key: "tripCode", label: "Trip Code", sortable: true, filterable: true, preferredWidth: 120, cellType: "text", value: (o) => o.tripCode },
        {
            key: "orderDate",
            label: "Order Date",
            sortable: true,
            preferredWidth: 90,
            cellType: "text",
            value: (o) => o.orderDate,
            sortAscLabel: "Sort oldest first",
            sortDescLabel: "Sort newest first",
        },
    ]

    return (
        <SharedOrdersPage
            app={app}
            injectBootstrap={app?.connected === false}
            // @ts-ignore - shared frontend prop passthrough (lodge-only UI)
            disableOfflineDatePresets={app?.connected === false}
            disableConfirmWhenOffline={app?.connected === false}
            api={api}
            helpers={{
                formatStatus,
                getCurrentLocation,
                lastNameCommaFirstName,
                statusOptions: () => LODGE_STATUS_OPTIONS,
                validateConfirmOrder,
                formatTimeDashes,
                address,
                isOverseas,
                sleep,
                getSignatureImageUrl: (order) =>
                    order?.signature_img
                        ? `${import.meta.env.VITE_STATIC_PREFIX}${order.id}/${order.signature_img}`
                        : null,
            }}
            showCloneOrders={showCloneOrders}
            showBasicOrderButton={false}
            showAllLocationsBadge={false}
            enableLocationFilter={false}
            showCurrentYearFilter={true}
            desktopColumns={desktopColumns}
            belowHeaderSlot={({ offlineSelectedOrders, setOfflineSelectedOrders }) => (
                app?.offlineCapabilities ? (
                    <OfflineOrdersSection
                        onSelectionChange={setOfflineSelectedOrders}
                    />
                ) : null
            )}
            enableActionsDropdown={true}
            enableBulkConfirmEmails={false}
        />
    )
}
